import Bookmark from "../../../../../../shared/components/Bookmark/Bookmark";
import LanguageToggle from "../../../../../../shared/components/LanguageToggle/LanguageToggle";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import images from "../../../../../../utilities/images/images";
import "./QuestionHeader.css";

const QuestionHeader = () => {
  const { selector } = useAppHooks();

  const { currentQuestionIndex, questionsData } = selector(
    (state) => state.examSlice
  );

  const currentQuestion = questionsData?.[currentQuestionIndex];

  // ✅ Calculate section-wise question number
  let sectionQuestionNumber = 1;

  if (currentQuestion && questionsData?.length) {
    const currentSectionKey = `${currentQuestion.subject} ${
      currentQuestion.section_name || ""
    }`.trim();

    const sectionQuestions = questionsData.filter((q) => {
      const key = `${q.subject} ${q.section_name || ""}`.trim();
      return key === currentSectionKey;
    });

    const indexInSection = sectionQuestions.findIndex(
      (q) => q.qid === currentQuestion.qid
    );

    sectionQuestionNumber = indexInSection + 1;
  }

  return (
    <div className="integration-container">
      <div className="integration-left">
        <span className="question-label">Q. {sectionQuestionNumber}</span>
        <span className="question-divider"> | </span>
        <span className="question-type">
          {currentQuestion?.answer_type || "—"}
        </span>
      </div>

      <div className="integration-right">
        <Bookmark
          defaultImage={images.new_bookmark}
          activeImage={images.new_bookmark}
        />
        <LanguageToggle />
      </div>
    </div>
  );
};

export default QuestionHeader;
